// MARK:- OS 2.0 controller for the mega-menu's collection-menu-linklist block.
//
// Mirrors the legacy `tabs` markup (`.tabs__trigger-wrapper`, `.tab-content`,
// `.is-active`, `.is-inactive`) so the legacy SCSS in
// src/scss/components/_tabs.scss + src/scss/base/_helpers.scss handles ALL
// of the show/hide and trigger-dim styling for free. This file only toggles
// the classes -- no positioning, no fades, no overlay logic.
//
// File: standalone hand-edited asset, NOT a build output. Loaded from
// sections/header.liquid via:
//
//   <script src="{{ 'component-menu-collection-linklist.js' | asset_url }}" type="module"></script>
//
// Why document-level delegation (not a wrapping <as-X> element): inserting
// a custom element between mega-menu's `.row` and our `.column` would break
// legacy `.row > .column` direct-child rules. Document-level delegation
// keeps the existing DOM intact -- same pattern as component-drawer.js.
// Customizer section reloads work for free because listeners are bound to
// `document`, not to elements that get torn down on reload.
//
// Markup contract (data-as-* prefixed to avoid colliding with the legacy
// jQuery's `data-tab-hover` / `data-tab-content` attributes on master):
//
//   <!-- Two columns, siblings inside mega-menu's .row, sharing data-collection-linklist-id -->
//   <div class="column drawer__content__left" data-collection-linklist-id="{block.id}">
//     <ul class="tabs__trigger-wrapper hover-list hover-list--light">
//       <li><a class="cta" data-as-tab-hover="{block.id}-accessories">Accessories</a></li>
//     </ul>
//   </div>
//   <div class="column drawer__content__right tabs" data-collection-linklist-id="{block.id}">
//     <div class="tabs__content-wrapper">
//       <div class="tab-content is-active" data-as-tab-content="{block.id}-accessories">…cards…</div>
//     </div>
//   </div>
//
// Initial state is server-rendered: the first link with a non-empty
// collection has its `.tab-content` panel marked `is-active`, with no
// `is-inactive` on any trigger (rest = all links full opacity).
//
// Hover behavior:
// - mouseover a trigger: that trigger keeps `is-active`, others get
//   `is-inactive` (legacy SCSS dims them via `.hover-list a.is-inactive`);
//   matching panel gets `is-active`, other panels lose it.
// - mouseout to anywhere outside the same scope's two columns: revert to
//   the rest state (no triggers `is-inactive`, only the first panel
//   `is-active`).
//
// Mobile/touch: desktop-only markup -- the mega-menu drawer itself is
// hidden via `.large-up`. Hover events don't fire on touch. No fallback
// needed.

let initialized = false;

function findScope(element) {
  const node = element.closest('[data-collection-linklist-id]');
  return node ? node.dataset.collectionLinklistId : null;
}

function getColumns(scopeId) {
  const id = CSS.escape(scopeId);
  return {
    links: document.querySelector(
      `.drawer__content__left[data-collection-linklist-id="${id}"]`,
    ),
    products: document.querySelector(
      `.drawer__content__right[data-collection-linklist-id="${id}"]`,
    ),
  };
}

function activate(scopeId, tabId) {
  const { links, products } = getColumns(scopeId);
  if (!links || !products) return;

  links.querySelectorAll('[data-as-tab-hover]').forEach((trigger) => {
    const isActive = trigger.dataset.asTabHover === tabId;
    trigger.classList.toggle('is-inactive', !isActive);
  });

  products.querySelectorAll('[data-as-tab-content]').forEach((panel) => {
    panel.classList.toggle('is-active', panel.dataset.asTabContent === tabId);
  });
}

function reset(scopeId) {
  const { links, products } = getColumns(scopeId);
  if (!links || !products) return;

  links.querySelectorAll('[data-as-tab-hover]').forEach((trigger) => {
    trigger.classList.remove('is-inactive');
  });

  const panels = products.querySelectorAll('[data-as-tab-content]');
  panels.forEach((panel, i) => {
    panel.classList.toggle('is-active', i === 0);
  });
}

function init() {
  if (initialized) return;
  initialized = true;

  document.addEventListener('mouseover', (event) => {
    const trigger = event.target.closest('[data-as-tab-hover]');
    if (!trigger) return;
    if (event.relatedTarget && trigger.contains(event.relatedTarget)) return;

    const scopeId = findScope(trigger);
    if (!scopeId) return;

    activate(scopeId, trigger.dataset.asTabHover);
  });

  document.addEventListener('mouseout', (event) => {
    const fromTrigger = event.target.closest('[data-as-tab-hover]');
    if (!fromTrigger) return;

    const scopeId = findScope(fromTrigger);
    if (!scopeId) return;

    const movingTo = event.relatedTarget;
    if (!movingTo) {
      reset(scopeId);
      return;
    }

    // Stay while moving anywhere within the same scope (sibling trigger,
    // see-all link, or the cards on the right).
    const { links, products } = getColumns(scopeId);
    if (links && links.contains(movingTo)) return;
    if (products && products.contains(movingTo)) return;

    reset(scopeId);
  });

  document.addEventListener('shopify:section:load', () => {
    document
      .querySelectorAll('[data-collection-linklist-id]')
      .forEach((node) => reset(node.dataset.collectionLinklistId));
  });
}

init();
